import React from 'react'
import { IndexLink } from 'react-router'

export default class Nav extends React.Component {
  goTo(route) {
    this.props.history.replace(`/${route}`)
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  getAuthBotton(isAuthenticated){
    // if(!isAuthenticated()){
    //   return (
    //     <li role="presentation">
    //     <IndexLink activeClassName='ms-active' to="/home" onClick={this.login.bind(this)}>Login</IndexLink>
    //     </li>
    //    )
    //   } else
    if(isAuthenticated()){
      return (
        <li role="presentation">
          <IndexLink activeClassName='ms-active' to="/" onClick={this.logout.bind(this)}>Logout</IndexLink>
        </li>
      )
    }
  }
  render(){
    const { isAuthenticated } = this.props.auth;
    const authLink = this.getAuthBotton(isAuthenticated)
    return(
      <ul className="nav nav-pills">
            <li role="presentation"><IndexLink activeClassName='ms-active' to="/home">Main</IndexLink></li>
            <li role="presentation"><IndexLink activeClassName='ms-active' to="/jobs">Jobs</IndexLink></li>
            {/* <li role="presentation"><IndexLink activeClassName='ms-active' to="/workers">Workers</IndexLink></li> */}
            <li role="presentation"><IndexLink activeClassName='ms-active' to="/servers">Cloud</IndexLink></li>
            {authLink}
      </ul>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav.js